import { Fragment, type ReactNode } from 'react';

type TopBarProps = {
  title?: string;
  crumbs?: string[];
  right?: ReactNode;
};

export function TopBar({ title, crumbs, right }: TopBarProps) {
  return (
    <div
      style={{
        height: 44,
        borderBottom: '1px solid var(--line)',
        background: 'var(--paper)',
        display: 'flex',
        alignItems: 'center',
        padding: '0 16px',
        gap: 12,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1, minWidth: 0 }}>
        {crumbs?.map((c, i) => (
          <Fragment key={i}>
            {i > 0 && <span style={{ color: 'var(--ink-4)' }}>/</span>}
            <span
              style={{
                color: i === (crumbs.length - 1) ? 'var(--ink)' : 'var(--ink-3)',
                fontSize: 13,
                fontWeight: i === crumbs.length - 1 ? 550 : 400,
              }}
            >
              {c}
            </span>
          </Fragment>
        ))}
        {title && <span style={{ fontWeight: 550, fontSize: 13.5 }}>{title}</span>}
      </div>
      {right}
    </div>
  );
}
